import { Loader2, Inbox } from "lucide-react";

export function LoadingRow() {
  return (
    <div className="flex items-center gap-3 text-tw-muted font-mono text-xs tracking-widest py-16 justify-center">
      <Loader2 className="animate-spin" size={16} /> LADEN…
    </div>
  );
}

export function EmptyState({ label, hint, testId }) {
  return (
    <div
      className="border border-dashed border-tw py-16 flex flex-col items-center text-center"
      data-testid={testId}
    >
      <Inbox size={40} className="text-tw-muted mb-4" />
      <div className="font-display text-2xl font-black text-white">{label}</div>
      <div className="text-sm text-tw-muted mt-2">{hint}</div>
    </div>
  );
}

export function StatCard({ label, value, sub, accent }) {
  return (
    <div className="bg-tw-surface border border-tw p-4 relative overflow-hidden">
      <div className="absolute top-0 left-0 h-full w-1" style={{ backgroundColor: accent }} />
      <div className="font-mono text-[10px] tracking-[0.3em] text-tw-muted uppercase">{label}</div>
      <div className="font-display text-3xl sm:text-4xl font-black text-white mt-2 leading-none">{value}</div>
      {sub !== undefined && sub !== null && (
        <div className="font-mono text-[10px] text-tw-muted mt-2 uppercase tracking-widest">{sub}</div>
      )}
    </div>
  );
}

export function MiniStat({ label, value, testId }) {
  return (
    <div className="text-center" data-testid={testId}>
      <div className="font-display text-2xl font-black text-white">{value}</div>
      <div className="font-mono text-[9px] text-tw-muted uppercase tracking-[0.1em] mt-1">{label}</div>
    </div>
  );
}

export function StatChip({ label, value, accent, testId }) {
  const color =
    accent === "green" ? "text-[#32D74B]" :
    accent === "muted" ? "text-tw-muted" : "text-tw-yellow";
  return (
    <div className="bg-tw-surface border border-tw p-4" data-testid={testId}>
      <div className="font-mono text-[9px] tracking-[0.3em] text-tw-muted">
        {label}
      </div>
      <div className={`text-3xl font-bold mt-1.5 ${color}`}>{value}</div>
    </div>
  );
}

export function DiagRow({ ok, label, testId }) {
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testId}>
      <span
        aria-hidden
        className={`inline-block w-2 h-2 ${ok ? "bg-[#32D74B]" : "bg-tw-red"}`}
      />
      <span className="text-tw-muted">
        {label}:{" "}
        <span className={ok ? "text-[#32D74B]" : "text-tw-red"}>
          {ok ? "OK" : "ontbreekt"}
        </span>
      </span>
    </span>
  );
}
